import React from 'react';
import axios from 'axios';
import { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Contact(props) {
    const [inputField, setInputField] = useState({
        name: '',
        phone: '',
        msg: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputField(prev => ({ ...prev, [name]: value }));
    };

    const formSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        axios.post('https://gtfundcrop.com/Rest5/contact_api/' + localStorage.getItem('userid'), {
            name: inputField.name,
            mobile: inputField.phone,
            message: inputField.msg,
            email: '',
            subject: 'Enq Mail'
        })
        .then((res) => {
            alert(res.data.msg);
            setInputField({ name: '', phone: '', msg: '' });
            navigate('/settings');
        })
        .catch((err) => {
            alert("Error submitting enquiry");
            console.error(err);
        })
        .finally(() => setIsLoading(false));
    };

    return (
        <div className="safearea bg-soft">
            <Helmet>
                <title>Contact Enquiry</title>
            </Helmet>

            {/* Modern Header */}
            <header className="app-header bg-primary text-white shadow-sm">
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn btn-ghost-light me-2">
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0">Contact Enquiry</h1>
                    </div>
                </div>
            </header>

            <main className="container py-4 mt-5">
                <div className="card border-0 shadow-sm rounded-lg overflow-hidden">
                    <div className="card-body p-4">
                        <form onSubmit={formSubmit}>
                            <div className="form-group mb-4">
                                <label htmlFor="name" className="form-label fw-medium text-muted">
                                    Your Name
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={inputField.name}
                                    onChange={handleChange}
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="phone" className="form-label fw-medium text-muted">
                                    Phone Number
                                </label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={inputField.phone}
                                    onChange={handleChange}
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter phone number"
                                    required
                                />
                            </div>

                            <div className="form-group4 mb-">
                                <label htmlFor="msg" className="form-label fw-medium text-muted">
                                    Your Message
                                </label>
                                <textarea
                                    id="msg"
                                    name="msg"
                                    rows="4"
                                    value={inputField.msg}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Type your message here..."
                                    required
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary btn-sm w-100 py-3 mt-3 fw-bold"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                        Submitting...
                                    </>
                                ) : (
                                    'Submit Enquiry'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    );
}